// extracted by mini-css-extract-plugin
export default {"container":"LeadingContent-module__container--CC4ob"};